import type { MergedSymbolInfo } from './dx-trading-mappers'

export const DEFAULT_SYMBOL_INFO: MergedSymbolInfo['symbolInfo'] = {
  tick_size: 0.00001,
  display_tick_size: 0.00001,
  max_tick_precision: 5,
  quote_currency: 'USD',
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

function numberField(record: Record<string, unknown>, key: string): number | undefined {
  const value = record[key]
  return typeof value === 'number' ? value : undefined
}

function stringField(record: Record<string, unknown>, key: string): string | undefined {
  const value = record[key]
  return typeof value === 'string' ? value : undefined
}

export function extractChartSymbolInfo(rawSymbolInfo: unknown): MergedSymbolInfo['symbolInfo'] {
  if (!isRecord(rawSymbolInfo)) {
    return DEFAULT_SYMBOL_INFO
  }

  const candidate =
    isRecord(rawSymbolInfo.payload) &&
    Array.isArray(rawSymbolInfo.payload.results) &&
    isRecord(rawSymbolInfo.payload.results[0])
      ? rawSymbolInfo.payload.results[0]
      : rawSymbolInfo

  return {
    tick_size: numberField(candidate, 'tick_size') ?? DEFAULT_SYMBOL_INFO.tick_size,
    display_tick_size:
      numberField(candidate, 'display_tick_size') ??
      numberField(candidate, 'tick_size') ??
      DEFAULT_SYMBOL_INFO.display_tick_size,
    max_tick_precision: numberField(candidate, 'max_tick_precision') ?? DEFAULT_SYMBOL_INFO.max_tick_precision,
    quote_currency: stringField(candidate, 'quote_currency') ?? DEFAULT_SYMBOL_INFO.quote_currency,
  }
}
